import { userGetByIdDescription as description } from './description';
import { getById as execute } from './execute';

export { description, execute };
